import { queryOptions, useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'

import { ApiCaller } from '@graphit/callers'
import type { Type } from '@graphit/types'

import type { DeepPartial } from 'typeorm'

export const typesQueryOptions = queryOptions({
	queryKey: ['types'],
	queryFn: ApiCaller.getTypes
})

export const useTypesQuery = () => useSuspenseQuery(typesQueryOptions)

export const typesStatsQueryOptions = (sourceWorkspaceIds: string[], targetWorkspaceIds: string[]) =>
	queryOptions({
		queryKey: ['types', 'stats', { sourceWorkspaceIds, targetWorkspaceIds }],
		queryFn: () => ApiCaller.getTypeIdsWithCountAndProperties(sourceWorkspaceIds, targetWorkspaceIds)
	})

export const useTypesStatsQuery = (sourceWorkspaceIds: string[], targetWorkspaceIds: string[]) =>
	useSuspenseQuery(typesStatsQueryOptions(sourceWorkspaceIds, targetWorkspaceIds))

export const useCreateTypeMutation = () => {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (typeData: DeepPartial<Type>) => ApiCaller.createType(typeData),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['types'] })
	})
}

export const useUpdateTypeMutation = () => {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: ({ id, typeData }: { id: string; typeData: DeepPartial<Type> }) =>
			ApiCaller.updateType(id, typeData),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['types'] })
	})
}

export const useDeleteTypeMutation = () => {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: ApiCaller.deleteType,
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['types'] })
	})
}
